(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-chart"] && !Shopify.designMode) return;
  try {
    (function () {
    function fmt(n) {
      return String(Math.round(n * 100) / 100);
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var tab = target.closest('[data-sc-tab]');
      if (tab) {
        var tabRoot = tab.closest('[data-size-chart]');
        if (!tabRoot) return;
        var index = tab.getAttribute('data-sc-tab');

        tabRoot.querySelectorAll('[data-sc-tab]').forEach(function (button) {
          var active = button === tab;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        tabRoot.querySelectorAll('[data-sc-panel]').forEach(function (panel) {
          panel.classList.toggle('is-hidden', panel.getAttribute('data-sc-panel') !== index);
        });
        return;
      }

      var unitButton = target.closest('[data-sc-unit]');
      if (unitButton) {
        var unitRoot = unitButton.closest('[data-size-chart]');
        if (!unitRoot) return;
        var unit = unitButton.getAttribute('data-sc-unit');
        unitRoot.setAttribute('data-unit', unit);

        unitRoot.querySelectorAll('[data-sc-unit]').forEach(function (button) {
          button.classList.toggle('is-active', button.getAttribute('data-sc-unit') === unit);
        });

        unitRoot.querySelectorAll('td[data-in]').forEach(function (cell) {
          var inches = parseFloat(cell.getAttribute('data-in'));
          if (isNaN(inches)) return;
          cell.textContent = unit === 'cm' ? fmt(inches * 2.54) : fmt(inches);
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
